import { cloneDeep } from "lodash";
import React, { useEffect, useMemo, useRef } from "react";
import * as THREE from "three";
import { mergeVertices } from "three/examples/jsm/utils/BufferGeometryUtils.js";
/**
 * @description create tooth function. In order to batch creation tooth
 * @param props The parameter passed by the attribute within the tag
 * */
function SuperimpositionModel(props) {
  /**
   * @param itemId String    component itemId
   * @param url String     model path
   * @param color String     model material color
   * */
  const { model, opacity = 1 } = props;

  const currentClickItemId = 1;
  const itemId = 2;

  const newModel = useMemo(() => {
    const clonedModel = cloneDeep(model);

    const vertices = clonedModel.attributes.position.array;
    const normal = clonedModel.attributes.normal.array;
  
    for (let i = 0; i < vertices.length; i += 3) {
      const vertex = new THREE.Vector3(
        vertices[i],
        vertices[i + 1],
        vertices[i + 2]
      );
      let normalVertex = new THREE.Vector3(
        normal[i],
        normal[i + 1],
        normal[i + 2]
      );
  
      normalVertex = normalVertex.multiplyScalar(0.01);
  
      vertices[i] = vertex.x - normalVertex.x;
      vertices[i + 1] = vertex.y - normalVertex.y;
      vertices[i + 2] = vertex.z - normalVertex.z;
    }

    clonedModel.computeVertexNormals();
    clonedModel.attributes.position.needsUpdate = true;

    return clonedModel;
  }, [model]);

  return (
    <mesh
      geometry={newModel}
      renderOrder={1}
      matrixAutoUpdate={false}
      opacity={opacity}
    >
      <meshPhysicalMaterial
        attach="material"
        color={currentClickItemId == itemId ? "#0000CD" : "#6495ED"}
        opacity={opacity > 0.5 ? 0.5 : opacity}
        transparent={true}
        depthWrite={opacity > 0.5 ? true : false}
        depthTest={true}
        clearcoat={1}
        clearcoatRoughness={0.3}
        roughness={0.2}
        metalness={0}
        reflectivity={0.3}
        emissive={"#FFFAF0"}
        emissiveIntensity={0.05}
      />
    </mesh>
  );
}

export default SuperimpositionModel;
